import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.ProductsInventoryPage',
    defaultMessage: 'Products > Inventory',
    id: 'AOrpwj',
  },
});

export const hotkey = ['g', 'i'];
export const barcodeContent = '+ZUXE6US2NG8C=';

const GotoProductsInventoryPage = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push('/products/inventory'), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['gi'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoProductsInventoryPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoProductsInventoryPage;
